import {
    QueryCompetorList,
    QueryCustomerHome,
    QueryHomeCustomer,
    QueryHomeIncome,
    QueryHomeReturn,
    QueryHomeVisit,
    QueryMainData,
    QueryVisitHome
} from '../../request/home';

export default {
    namespace: true,
    state: {},

    mutations: {},
    actions: {
        QUERY_HOME_CUSTOMER: async ({ commit }, payload) => {
            let res = await QueryHomeCustomer(payload);
            return res;
        },

        QUERY_HOME_INCOME: async ({ commit }, payload) => {
            let res = await QueryHomeIncome(payload);
            return res;
        },

        QUERY_HOME_RETURN: async ({ commit }, payload) => {
            let res = await QueryHomeReturn(payload);
            return res;
        },

        QUERY_HOME_VISIT: async ({ commit }, payload) => {
            let res = await QueryHomeVisit(payload);
            return res;
        },

        QUERY_COMEPTIOR_LIST: async ({ commit }, payload) => {
            let res = await QueryCompetorList(payload);
            return res;
        },

        // ------

        QUERY_CUSTOMER_HOME: async ({ commit }, payload) => {
            let res = await QueryCustomerHome(payload);
            return res;
        },

        QUERY_VISIT_HOME: async ({ commit }, payload) => {
            let res = await QueryVisitHome(payload);
            return res;
        },
        QUERY_MAIN_DATA: async ({}, payload) => {
            let res = await QueryMainData(payload);
            return res;
        }
    }
};
